/** O titulo do livro: a linha da lista de tanques leva ate ele. */
export const ID_DO_LIVRO = 'livro-do-tanque';

/**
 * A LINHA DO TANQUE ABRE O LIVRO (robos no QAS, 20/10/2026, item 13): a linha
 * tem cursor de mao e trocava o livro la embaixo, abaixo das transferencias e
 * dos pedidos de ajuste — fora da vista, parecia que o clique nao fazia nada.
 * Agora o clique leva a tela ate o livro do tanque escolhido e poe o foco no
 * titulo dele. Com reducao de movimento, sem rolagem animada.
 */
export function mostrarLivroDoTanque(): void {
  window.requestAnimationFrame(() => {
    const titulo = document.getElementById(ID_DO_LIVRO);
    if (!titulo) return;
    const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    titulo.scrollIntoView({ behavior: semMovimento ? 'auto' : 'smooth', block: 'start' });
    titulo.focus({ preventScroll: true });
  });
}
